/* ==========================================================================
   Pawfect Treats — global UI (menu, reveal, wishlist, product page)
   Cart/AJAX lives in cart.js.
   ========================================================================== */
(function () {
  'use strict';
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => [...(r || document).querySelectorAll(s)];

  /* ---- reveal on scroll + count-up stats (never leaves content hidden) ---- */
  const rv = $$('.rv');
  const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // subtle stagger for grouped reveals (siblings animate one after another)
  if (!reduce) {
    const groups = new Map();
    rv.forEach(el => { const p = el.parentElement; if (!groups.has(p)) groups.set(p, []); groups.get(p).push(el); });
    const stagger = () => { groups.forEach(list => { if (list.length > 1) list.forEach((el, i) => { el.style.transitionDelay = Math.min(i * 70, 350) + 'ms'; }); }); };
    requestAnimationFrame(stagger);
  }

  const counted = new WeakSet();
  function countUp(el) {
    if (counted.has(el)) return; counted.add(el);
    const raw = (el.dataset.c || el.textContent || '').trim();
    const m = raw.match(/^([^\d]*)([\d,]+)(.*)$/);
    if (!m) return;
    const pre = m[1], target = parseInt(m[2].replace(/,/g, ''), 10), suf = m[3], comma = m[2].indexOf(',') !== -1;
    if (!isFinite(target) || reduce) { return; }
    const dur = 1300; let t0 = null;
    const fmt = n => comma ? n.toLocaleString() : String(n);
    const done = () => { el.textContent = pre + fmt(target) + suf; };
    (function step(ts) { if (!t0) t0 = ts; const p = Math.min((ts - t0) / dur, 1); const e = 1 - Math.pow(1 - p, 3);
      el.textContent = pre + fmt(Math.round(e * target)) + suf; if (p < 1) requestAnimationFrame(step); else done(); })(performance.now());
    setTimeout(done, dur + 600); // guarantee final value even if rAF is throttled (background tab)
  }

  const revealAll = () => { rv.forEach(el => el.classList.add('is-in')); $$('[data-c]').forEach(countUp); };
  if ('IntersectionObserver' in window && !reduce) {
    const io = new IntersectionObserver((es) => {
      es.forEach(e => { if (e.isIntersecting) {
        e.target.classList.add('is-in');
        if (e.target.matches && e.target.matches('[data-c]')) countUp(e.target);
        $$('[data-c]', e.target).forEach(countUp);
        io.unobserve(e.target);
      } });
    }, { rootMargin: '0px 0px -8% 0px' });
    rv.forEach(el => io.observe(el));
    $$('[data-c]').forEach(el => { if (!el.closest('.rv')) io.observe(el); });
    setTimeout(revealAll, 1600);
  } else { revealAll(); }

  /* ---- mobile menu ---- */
  const burger = $('#burger'), mMenu = $('#mMenu');
  if (burger && mMenu) {
    burger.addEventListener('click', () => {
      const open = mMenu.classList.toggle('open');
      burger.setAttribute('aria-expanded', open);
      document.body.style.overflow = open ? 'hidden' : '';
    });
  }

  /* ---- mega menu (touch/keyboard support; hover handled by CSS) ---- */
  $$('.nav-links > li').forEach(li => {
    const top = $('.nav-top', li);
    if (!top) return;
    top.addEventListener('click', () => li.classList.toggle('open'));
    top.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); li.classList.toggle('open'); } });
  });

  /* ---- marquee: duplicate for a seamless loop ---- */
  const marq = $('#marq');
  if (marq && marq.children.length === 1) marq.appendChild(marq.firstElementChild.cloneNode(true));

  /* ---- wishlist (localStorage) ---- */
  const WKEY = 'pf-wish';
  const loadW = () => { try { return new Set(JSON.parse(localStorage.getItem(WKEY) || '[]')); } catch (e) { return new Set(); } };
  const wish = loadW();
  const saveW = () => { try { localStorage.setItem(WKEY, JSON.stringify([...wish])); } catch (e) {} };
  function paintWish() {
    $$('.js-wish-count').forEach(b => { b.textContent = wish.size; b.classList.toggle('hide', wish.size === 0); });
    $$('.heart').forEach(h => { const on = wish.has(h.dataset.w); h.classList.toggle('on', on); h.setAttribute('aria-pressed', on); });
  }
  function emitWish(id, added) {
    document.dispatchEvent(new CustomEvent('pf:wish', { detail: { id: id, added: added, handles: [...wish] } }));
  }
  document.addEventListener('click', e => {
    const h = e.target.closest('.heart');
    if (!h) return;
    e.preventDefault();
    const id = h.dataset.w;
    wish.has(id) ? wish.delete(id) : wish.add(id);
    saveW(); paintWish();
    emitWish(id, wish.has(id));
    window.pfToast && window.pfToast(wish.has(id) ? 'Saved for later' : 'Removed from saved');
  });
  window.pfWish = {
    list: () => [...wish],
    has: id => wish.has(id),
    remove: id => {
      if (!wish.delete(id)) return false;
      saveW(); paintWish(); emitWish(id, false);
      return true;
    },
    sync: ids => {
      wish.clear();
      (ids || []).forEach(id => { if (id) wish.add(String(id)); });
      paintWish();
    }
  };
  paintWish();

  /* ---- bottom-nav active state ---- */
  const path = location.pathname;
  $$('.botnav .bn-i').forEach(a => {
    const href = a.getAttribute('href');
    if (href === path || (href !== '/' && path.indexOf(href) === 0)) a.classList.add('active');
    else if (href === '/' && path === '/') a.classList.add('active');
  });

  /* ---- money format (Shopify) ---- */
  const moneyFmt = (window.PF && PF.moneyFormat) || '${{amount}}';
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    let value = '';
    const num = (cents / 100.0);
    const fmt = moneyFmt;
    function frac(n, p, t, d) {
      p = p == null ? 2 : p; t = t == null ? ',' : t; d = d == null ? '.' : d;
      const neg = n < 0 ? '-' : ''; n = Math.abs(Number(n) || 0).toFixed(p);
      const parts = n.split('.'), intp = parts[0], frp = parts[1] ? d + parts[1] : '';
      return neg + intp.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + t) + frp;
    }
    const placeholder = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    switch (placeholder && placeholder[1]) {
      case 'amount': value = frac(num, 2); break;
      case 'amount_no_decimals': value = frac(num, 0); break;
      case 'amount_with_comma_separator': value = frac(num, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = frac(num, 0, '.', ','); break;
      case 'amount_with_space_separator': value = frac(num, 2, ' ', ','); break;
      default: value = frac(num, 2);
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
  }
  window.pfMoney = formatMoney;

  /* ---- product page ---- */
  const pForm = $('#productForm');
  const pjEl = $('#ProductJson');
  if (pForm && pjEl) {
    let product; try { product = JSON.parse(pjEl.textContent); } catch (e) { product = null; }
    const selected = {}; // optionIndex -> value
    $$('.opts', pForm).forEach(g => {
      const idx = +g.dataset.optIndex;
      const on = $('.opt.on', g) || $('.opt', g);
      if (on) selected[idx] = on.dataset.value;
    });
    let qty = 1;

    function currentVariant() {
      if (!product) return null;
      if (product.variants.length === 1) return product.variants[0];
      return product.variants.find(v => {
        return Object.keys(selected).every(i => v.options[i] === selected[i]);
      }) || null;
    }
    function refresh() {
      const v = currentVariant();
      const idInput = $('#variantId'), addBtn = $('#pAdd'), price = $('#pPrice'), addP = $('#pAddP'), stock = $('#pStock');
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (price) price.innerHTML = (v.compare_at_price > v.price) ? formatMoney(v.price) + ' <span class="old">' + formatMoney(v.compare_at_price) + '</span>' : formatMoney(v.price);
      if (stock) stock.textContent = v.available ? 'In stock' : 'Sold out';
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.innerHTML = v.available ? ('Add to bowl · <span id="pAddP">' + formatMoney(v.price * qty) + '</span>') : 'Sold out';
      }
      // swap gallery to the variant image if present
      if (v.featured_image && v.featured_image.src) { const g = $('#galMain'); if (g) g.src = v.featured_image.src; }
    }

    pForm.addEventListener('click', e => {
      const opt = e.target.closest('.opt');
      if (opt) {
        const g = opt.closest('.opts');
        $$('.opt', g).forEach(o => o.classList.remove('on'));
        opt.classList.add('on');
        selected[+g.dataset.optIndex] = opt.dataset.value;
        refresh();
        return;
      }
      const q = e.target.closest('[data-q]');
      if (q) {
        qty = Math.max(1, qty + (+q.dataset.q));
        const qEl = $('#pQ'); if (qEl) qEl.textContent = qty;
        refresh();
      }
    });
    window.pfQty = () => qty;
    refresh();

    /* tabs */
    function showTab(id) {
      const btn = $$('.tb').find(x => x.dataset.t === id);
      if (!btn) return;
      $$('.tb').forEach(x => x.classList.toggle('on', x === btn));
      $$('.tp').forEach(p => p.classList.toggle('on', p.dataset.p === id));
    }
    $$('.tb', document).forEach(b => b.addEventListener('click', () => showTab(b.dataset.t)));
    document.addEventListener('click', e => {
      const link = e.target.closest('a[data-tab]');
      if (!link) return;
      showTab(link.dataset.tab);
    });

    /* gallery thumbnails */
    $$('.gal-th button').forEach(btn => btn.addEventListener('click', () => {
      const src = btn.dataset.img; const main = $('#galMain');
      if (src && main) main.src = src;
      $$('.gal-th button').forEach(b => b.classList.toggle('on', b === btn));
    }));
  }
})();
